import React from "react";

export default function History_Languages() {
  return (
    <div>
      <h1>History_Languages</h1>
      <p>This is the History_Languages component.</p>
    </div>
  );
}
